import React from 'react';
import * as DateFns from 'date-fns';

import { NUMBER_OF_WEEK_DAYS } from '../../../config/constants';

const MonthDaysHeader = () => {
  
  const daysWeek = [];
  const startDate = DateFns.startOfWeek(new Date());
  for (let i = 0; i < NUMBER_OF_WEEK_DAYS; i++) {
    daysWeek.push(
      <div className="month-days-col" key={i}>
        {DateFns.format(DateFns.addDays(new Date(startDate), i), 'EEE')}
      </div>
    );
  }
  
  return <div className="month-days" id={'Month-days'}>{daysWeek}</div>;
};

export default MonthDaysHeader;